import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cheapcabserviceinpune() {



  const cardData =
  {
    keyword: ' Cheap Cab Service in Pune   ',
    heading: 'Sai Trupti Cabs:  Cheap Cab Service in Pune   ',
    headingDescription: 'Sai Trupti Cabs offers reliable and cheap cab service in Pune, ideal for affordable local travel, airport transfers, and outstation trips without compromising on comfort and safety. Our fleet includes well-maintained AC sedans, SUVs, Innova Crysta, and budget-friendly vehicles, all equipped with clean interiors and ample luggage space for a comfortable ride. Every trip is handled by a professional, background-verified driver who ensures timely pickup, safe driving, and courteous service across Pune. We provide flexible options like low-cost local cab booking, cheap airport pickup and drop, and budget outstation taxi services at transparent pricing with no hidden charges. With 24x7 online cab booking, instant confirmation, and dedicated customer support, Sai Trupti Cabs makes your travel in Pune economical, convenient, and completely hassle-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies, and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



 "services": [
    {
      "name": "Cheap Cab Service Pune",
      "description": "Affordable cab service in Pune offering AC and non-AC vehicles for local and outstation travel. Professional drivers, flexible pickup/drop points, luggage support, real-time tracking, and transparent fares make it ideal for students, families, and budget-conscious travelers seeking reliable transportation."
    },
    {
      "name": "Cheap Cabs in Pune",
      "description": "Economical cab service in Pune with low fares, multiple vehicle options, AC/non-AC rides, professional drivers, luggage support, and flexible pickup/drop points. Perfect for local trips, airport transfers, and city commutes without compromising comfort."
    },
    {
      "name": "Cheap Taxi in Pune",
      "description": "Low-cost taxi service in Pune providing reliable AC/non-AC rides, experienced drivers, luggage assistance, and transparent fares. Suitable for daily commutes, local sightseeing, and affordable point-to-point travel."
    },
    {
      "name": "Pune to Mumbai Cheap Cabs",
      "description": "Budget-friendly cab service from Pune to Mumbai offering AC/non-AC Sedans, SUVs, and Innova cars. Features professional drivers, luggage support, flexible pickup/drop points, and transparent fares for cost-effective long-distance travel."
    },
    {
      "name": "Best Cab Service in Pune",
      "description": "Top-rated cab service in Pune providing AC/non-AC vehicles, professional drivers, luggage assistance, real-time tracking, and flexible schedules. Perfect for corporate clients, airport transfers, family trips, and city travel."
    },
    {
      "name": "Best Cab Service Pune to Mumbai",
      "description": "Premium cab service from Pune to Mumbai with comfortable AC/non-AC vehicles including Sedans, SUVs, and Innova. Features professional drivers, luggage support, flexible pickup/drop points, real-time tracking, and safe long-distance travel."
    },
    {
      "name": "Best Taxi Service in Pune",
      "description": "Reliable taxi service in Pune offering AC/non-AC rides, experienced drivers, luggage assistance, flexible pickup/drop points, real-time tracking, and transparent fares for local or outstation travel."
    },
    {
      "name": "Best Outstation Cab Service in Pune",
      "description": "Professional outstation cab service in Pune with AC/non-AC Sedans, SUVs, Innova, and luxury vehicles. Features experienced drivers, luggage support, flexible schedules, real-time tracking, and cost-effective long-distance travel for families and corporate clients."
    },
    {
      "name": "Best Cab in Pune",
      "description": "Well-maintained AC/non-AC vehicles with professional drivers, luggage support, flexible pickup/drop points, and transparent fares. Ideal for local travel, airport transfers, and outstation trips from Pune."
    },
    {
      "name": "Best Cab Service from Pune to Goa",
      "description": "Reliable and comfortable cab service from Pune to Goa offering AC/non-AC vehicles including Sedans, SUVs, and Innova. Professional drivers, luggage assistance, flexible pickup/drop points, and transparent fares ensure safe and enjoyable long-distance travel."
    },
    {
      "name": "Best Cab Service from Pune to Mumbai Airport",
      "description": "Premium cab service from Pune to Mumbai Airport with AC/non-AC Sedans, SUVs, and luxury vehicles. Features professional drivers, luggage support, flexible pickup/drop points, real-time tracking, and safe airport transfers."
    },
    {
      "name": "Best Mumbai Pune Cab Service",
      "description": "Comfortable and reliable cab service between Mumbai and Pune offering AC/non-AC Sedans, SUVs, and Innova cars. Professional drivers, luggage assistance, flexible schedules, real-time tracking, and transparent fares for long-distance travel."
    },
    {
      "name": "Affordable Local Cab Service Pune",
      "description": "Budget-friendly city cab service in Pune offering low-cost AC/non-AC vehicles, experienced drivers, luggage support, flexible pickup/drop points, and transparent fares. Ideal for daily commutes and city sightseeing."
    },
    {
      "name": "Cheap Innova Cab in Pune",
      "description": "Low-cost Innova cab service in Pune providing comfortable AC rides for family trips, airport transfers, and group travel. Professional drivers, luggage support, flexible pickup/drop points, and transparent fares."
    },
    {
      "name": "Best Innova Crysta Cab Pune",
      "description": "Premium Innova Crysta cab service in Pune offering luxury AC rides, professional drivers, luggage support, flexible pickup/drop points, and safe travel for corporate clients, families, and group trips."
    },
    {
      "name": "Budget Ertiga Cab Pune",
      "description": "Affordable Ertiga cab service in Pune providing AC/non-AC rides for small to medium groups, professional drivers, luggage support, flexible pickup/drop points, and transparent fares for local and outstation travel."
    },
    {
      "name": "Cheap Sedan Cab Pune",
      "description": "Low-cost Sedan cab service in Pune offering smooth AC/non-AC rides, professional drivers, luggage assistance, flexible schedules, and transparent fares for solo travelers, couples, and small families."
    },
    {
      "name": "Best Tempo Traveller Service Pune",
      "description": "Spacious Tempo Traveller cab service in Pune for group travel, family trips, and corporate outings. AC vehicles, professional drivers, luggage support, flexible pickup/drop points, and reliable long-distance travel."
    }
  ],
  "tableData": [
    ["Cheap Cab Service Pune", "Cheap Cabs in Pune"],
    ["Cheap Taxi in Pune", "Pune to Mumbai Cheap Cabs"],
    ["Best Cab Service in Pune", "Best Cab Service Pune to Mumbai"],
    ["Best Taxi Service in Pune", "Best Outstation Cab Service in Pune"],
    ["Best Cab in Pune", "Best Cab Service from Pune to Goa"],
    ["Best Cab Service from Pune to Mumbai Airport", "Best Mumbai Pune Cab Service"],
    ["Affordable Local Cab Service Pune", "Cheap Innova Cab in Pune"],
    ["Best Innova Crysta Cab Pune", "Budget Ertiga Cab Pune"],
    ["Cheap Sedan Cab Pune", "Best Tempo Traveller Service Pune"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Cheap Cab Service in Pune",
    "WhyChoosedescription": "Sai Trupti Cabs offers affordable and reliable cab services in Pune — perfect for budget-conscious travelers, daily commutes, and short trips across the city."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Our cheap cab fares in Pune start from approximately ₹250 for local rides, with clear and upfront pricing — no hidden charges."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, or SUVs depending on your group size, luggage needs, and comfort preferences."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are experienced in navigating Pune city traffic, ensuring a safe, smooth, and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We offer convenient pickups and drop-offs anywhere in Pune, including homes, offices, hotels, and railway/metro stations."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized, and equipped with essential amenities for a comfortable and hygienic ride."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, route planning, and travel assistance for your Pune cab rides."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your cheap cab in Pune easily through a call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]



  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs offer cheap cab services in Pune?',
    answer: 'Yes, Sai Trupti Cabs provides reliable and affordable cab services for local travel, city rides, and budget trips in Pune.',
  },
  {
    question: 'How can I book a cheap cab in Pune with Sai Trupti Cabs?',
    answer: 'You can book your cab through our website, mobile app, WhatsApp, or by contacting our 24×7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for cheap cab service?',
    answer: 'We offer hatchbacks, sedans, and SUVs for economical and comfortable city rides.',
  },
  {
    question: 'Are the drivers experienced for local Pune trips?',
    answer: 'Yes, all our drivers are professional, courteous, and familiar with Pune city traffic routes.',
  },
  {
    question: 'Can I hire a cab for multiple trips or hourly rentals?',
    answer: 'Yes, we provide flexible options for hourly rentals, round trips, and multiple rides within Pune.',
  },
  {
    question: 'Is the cheap cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services in Pune for maximum convenience.',
  },
  {
    question: 'What are the fares for cheap cabs in Pune?',
    answer: 'Fares start from approximately ₹250 for local rides, with transparent pricing and no hidden charges.',
  },
  {
    question: 'What payment options are accepted for Pune cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune cabs?',
    answer: 'All vehicles are sanitized before every trip, and drivers follow strict hygiene and safety measures.',
  },
  {
    question: 'Is customer support available during Pune cab rides?',
    answer: 'Yes, our 24×7 customer support team is available throughout your cab journey in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sameer Kulkarni',
    feedback: 'Affordable and reliable cab service in Pune. Clean vehicle and polite driver made my ride comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritu Patil',
    feedback: 'Sai Trupti Cabs offers budget-friendly rides with professional drivers. Highly recommended!',
    rating: 5,
  },
];




















































































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Cheap Cab Service in Pune",
  "image": "https://saitrupticabs.com/assets/images/cheap-cab-pune.jpg",
  "description": "Sai Trupti Cabs offers cheap cab service in Pune with low fares for local travel, airport transfers and outstation trips. Book AC sedan, SUV and Innova Crysta taxi at affordable pricing with professional drivers and 24x7 support.",
  "provider": {
    "@type": "Organization",
    "name": "Sai Trupti Cabs",
    "url": "https://saitrupticabs.com"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "13680"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "999",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/cheap-cab-service-in-pune"
  }
};






  return (
    <div>

<Helmet>
  <title>Cheap Cab Service in Pune | Low Fare Taxi ₹999 | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book cheap cab service in Pune starting at ₹999. Affordable local, airport and outstation taxi with AC sedan, SUV and Innova Crysta. 24x7 cab booking with Sai Trupti Cabs." 
  />

  <meta 
    name="keywords" 
    content="cheap cab pune, affordable taxi pune, budget cab service pune, low cost taxi pune, cheapest cab pune, pune cheap taxi service, economy cab pune, cheap airport cab pune, cheap outstation cab pune, cheap sedan cab pune, budget innova cab pune, taxi fare pune low price, 24 hour cheap cab pune" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/98.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cheapcabserviceinpune;